import { useEffect, useState } from "react";
import { Avatar, Box, Button, Container, Grid, IconButton, Paper, Typography, useTheme } from "@mui/material";
import { useParams } from "react-router-dom";
import { GetData } from "../../../controllers/SmartCardsController";
import { imagesURL } from "../../../apiRoutes/apiBase";
import SocialComponent from "../../../components/socialComponent";
import Horarios from "../../../components/horarios";

import MapContainer from '../../../components/map';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft, faCalendarAlt, faCircleCheck, faMapMarkerAlt, faPhone, faStar, faTags, faMapLocation } from "@fortawesome/free-solid-svg-icons";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";



import { motion } from "framer-motion"
import ProductsCarousel from "../../../components/carousel";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import QUDProgress from "../../../components/progress";
import Review from "../../../components/review";
import Reserve from "../../../components/reserve";

import { useTranslation } from "react-i18next";
import { createView } from "../../../controllers/customer/ViewsController";
import ReadOnlyContent from "../../../components/ReadOnlyContent";
import PublicScheduleViewer from "../../../components/schedules/PublicScheduleViewer";



export default function MerchantProfile()
{
    const {t} = useTranslation();
    const [merchant,setMerchant] = useState([]);
    const [socials,setSocials] = useState([]);
    const [products,setProducts] = useState([]);
    const [workSchedueles,setWorkSchedules] = useState([]);

    const [openReview,setOpenReview] = useState(false);
    const [openReserve,setOpenReserve] = useState(false);

    const [isLoading,setIsLoading] = useState(false);

    const theme = useTheme();

    let { uuid } = useParams();
    
    const history = useHistory();
    const redirect = (route) => {
        history.push(route);
    }

    useEffect(()=>{
        window.scrollTo(0,0);
        handleGetData();
        handleReviewLocalStorage();
        handleReserveLocalStorage(); 
    },[]);


    const handleGetData = async () => {
        setIsLoading(true);
        let response = await GetData(uuid);
        if(response.success === true)
        {
            setMerchant(response.data.merchant);
            setSocials(response.data.redes);
            setProducts(response.data.productos);
            setWorkSchedules(response.data.horarios);
            createView('merchant',response.data.merchant.id,response.data.merchant.uuid);
        }
        else
        {
            console.log('Error en handleGetData');
        }
        setIsLoading(false);
    }

    const handleReviewLocalStorage = () => {
        if(localStorage.getItem('openModalReview') === 'true')
            setOpenReview(true)
    }

    const handleCloseReview = () => {
        localStorage.removeItem('openModalReview')
        setOpenReview(false)
    }

    const handleReserveLocalStorage = () => {
        if(localStorage.getItem('openModalReserve') === 'true')
            setOpenReserve(true)
    }

    const handleCloseReserve = () => {
        localStorage.removeItem('openModalReserve')
        setOpenReserve(false)
    }


        
    return(
        
        <Box sx={{ overflowX:'hidden',pb:5,pt:14}}>
            <QUDProgress open={isLoading}/>

            <Container spacing={3} maxWidth='xl'>
                <Grid container spacing={3}>
                    {/**DESCRIPCION DEL NEGOCIO */}
                    <Grid item xs={12} sm={12} md={6} lg={5} xl={5}>
                        <Grid container spacing={1} display={'flex'}>
                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                <IconButton onClick={()=>{redirect('/search/'+merchant.category)}}>
                                    <FontAwesomeIcon icon={faArrowLeft}/>
                                </IconButton>
                                <Box sx={{display:'flex',flexDirection:'row',justifyContent:'center'}}>
                                    <Avatar
                                        variant="rounded"
                                        alt={merchant.merchant}
                                        src={ merchant.profile_image}
                                        sx={{ width: 200, height: 200 }}
                                    />
                                </Box>
                            </Grid>

                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                <Typography variant="h4" fontWeight={'bold'}>
                                    {merchant.merchant}&nbsp;
                                    {merchant.certified === 1 && <FontAwesomeIcon size="2xs" color={theme.palette.link.main} icon={faCircleCheck}/>}
                                </Typography>
                                <Typography>({merchant.category})</Typography>
                            </Grid>
                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12} color={'primary.contrastAux'}>
                                <ReadOnlyContent
                                    htmlContent={merchant.descripcion}
                                />
                            </Grid>

                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12} mt={3}>
                                <Typography><FontAwesomeIcon icon={faMapLocation}/> {merchant.city}</Typography>
                            </Grid>
                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                <Typography><FontAwesomeIcon icon={faStar}/> {parseFloat(5).toFixed(1)}</Typography>
                            </Grid>
                            

                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12} mt={5}>
                                <Grid container spacing={3}>
                                    <Grid item>
                                        <Button sx={{display:'flex',flexDirection:'column'}}  target='_blank' href={`https://wa.me/${merchant.phone}`}>
                                            <FontAwesomeIcon size="2x" color={theme.palette.link.main} icon={faWhatsapp}/>
                                            <Typography variant="body1" color={theme.palette.link.main}>{t('actions.contact')}</Typography>
                                        </Button>
                                    </Grid>


                                    <Grid item>
                                        <Button
                                            sx={{ display: 'flex', flexDirection: 'column' }}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            href={`https://www.google.com/maps/search/?api=1&query=${merchant.latitude},${merchant.longitude}`}
                                        >
                                            <FontAwesomeIcon size="2x" color={theme.palette.link.main} icon={faMapLocation}/>
                                            <Typography variant="body1" color={theme.palette.link.main}>{t('actions.directions')}</Typography>
                                        </Button>
                                    </Grid>

                                    <Grid item>
                                        <Button
                                            sx={{display:'flex',flexDirection:'column'}}
                                             onClick={()=>setOpenReserve(true)}
                                        >
                                            <FontAwesomeIcon size="2x" color={theme.palette.link.main} icon={faCalendarAlt}/>
                                            <Typography variant="body1" color={theme.palette.link.main}>{t('actions.book')}</Typography>
                                        </Button>
                                    </Grid>

                                    <Grid item>
                                        <Button
                                            sx={{display:'flex',flexDirection:'column'}}
                                            onClick={()=>setOpenReview(true)}
                                        >
                                            <FontAwesomeIcon size="2x" color={theme.palette.link.main} icon={faStar}/>
                                            <Typography variant="body1" color={theme.palette.link.main}>{t('actions.review')}</Typography>
                                        </Button>
                                    </Grid>

                                    {
                                        products.length !== 0 &&
                                        <Grid item>
                                            <Button
                                                sx={{display:'flex',flexDirection:'column'}}
                                                onClick={()=>redirect('/merchants/'+merchant.uuid+'/menu')}
                                            >
                                                <FontAwesomeIcon size="2x" color={theme.palette.link.main} icon={faTags}/>
                                                <Typography variant="body1" color={theme.palette.link.main}>{t('actions.catalog')}</Typography>
                                            </Button>
                                        </Grid>
                                    }
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>

                    {/**Imagen del negocio */}
                    <Grid item xs={12} sm={12} md={6} lg={7} xl={7} sx={{display:{xs:'none',sm:'none',md:'flex',lg:'flex',xl:'flex'},alignItems:'center',justifyContent:'center'}}>
                        <motion.div
                                initial={{ opacity: 0,translateY:200 }}
                                whileInView={{ opacity: 1,translateY:0 }}
                                viewport={{ once: false }}
                                style={{display:'flex',flexDirection:'row',justifyContent:'right'}}
                            >
                                <img
                                    src={merchant.cover_image }
                                    alt='qud'
                                    style={{width:'90%',borderRadius:50}}
                                />
                        </motion.div>
                    </Grid>
                </Grid>
            </Container>


            
            {/**Productos destacados */}
            <Container sx={{mb:5,marginTop:5}} maxWidth='xl'>
                <Grid container spacing={3} justifyContent='center'>
                    {/**Products */}
                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12} mt={5}>
                        {
                            products.length !== 0 &&
                            <ProductsCarousel 
                                items={products}
                                merchant={merchant}
                                merchant_uuid={merchant.uuid}

                            />
                        }
                    </Grid>
                </Grid>
            </Container>

            
            {/**CONTACTANOS */}
            <Box 
                sx={{
                    //position:'relative',
                    height:280,
                    display:'flex',
                    alignItems:'center',
                    justifyContent:'center',
                    bgcolor:'primary.main',
                    //zIndex:1
                }}
            >
                <Typography variant="h4" color={'#FFF'}>
                    {merchant.apellido}
                </Typography>
            </Box>
            
            <Container sx={{mt:-10}}>
                <Grid container spacing={3} justifyContent={'center'}>
                    <Grid item xs={12} sm={12} md={12} xl={12} lg={12}>
                        <Paper elevation={4} sx={{padding:0}}>
                            <Grid container spacing={3}>
                                {/**Horarios */}
                                <Grid item xs={12} sm={12} md={8} lg={8} xl={8} >
                                    <Box sx={{ p: 2, height: '100%' }}>
                                        <PublicScheduleViewer schedules={workSchedueles}/>
                                    </Box>
                                </Grid>

                                {/**Datos de contacto */}
                                <Grid item xs={12} sm={12} md={4} lg={4} xl={4} sx={{bgcolor:'primary.main',borderBottomRightRadius:10,borderTopRightRadius:10,position:'relative'}}>
                                    <Box sx={{pl:4,pb:3,pr:4,color:'primary.contrastText',position:'relative',zIndex:100}}>
                                        <Grid container spacing={3}>
                                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                                <Typography variant="h5" fontWeight={'bold'}>{t('helpers.contactInformation')}</Typography>
                                            </Grid>
                                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                                <Typography fontWeight={'bold'}>
                                                    <FontAwesomeIcon icon={faMapMarkerAlt} /> &nbsp;&nbsp;
                                                    {merchant.address}
                                                </Typography>
                                            </Grid>
                                            
                                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                                <Typography fontWeight={'bold'}><FontAwesomeIcon icon={faPhone} />&nbsp;{merchant.phone}</Typography>
                                            </Grid>
                                            
                                            {
                                                socials.length !== 0 &&
                                                socials.map(item =>
                                                    <SocialComponent
                                                        //src={item.img}
                                                        //alt={item.nombre}
                                                        social={item.nombre}
                                                        username={item.username}
                                                        link={item.enlace}
                                                        color='#FFF'
                                                    /> 
                                                )
                                            }
                                        </Grid>
                                        
                                    </Box>
                                    <Box
                                        sx={{
                                            width:'100%',height:'100%',
                                            display:'flex',
                                            //justifyContent:'center',
                                            alignItems:'center',
                                            backgroundImage: "url(" + imagesURL+'empresas/'+merchant.imagen2 + ")",
                                            backgroundPosition:'center',
                                            backgroundRepeat:'no-repeat',
                                            backgroundSize:'cover',
                                            opacity:0.1,
                                            position:'absolute',
                                            bottom:0, left:0,top:0,
                                            borderTopRightRadius:10,
                                            borderBottomRightRadius:10
                                        }}
                                    ></Box>
                                </Grid>
                            </Grid>
                        </Paper>
                    </Grid>
                </Grid>
            </Container>

            <Container>
                <Grid container spacing={3} mt={5}>
                    {
                        merchant.length !== 0 &&
                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12} mt={5}>
                           
                                <Box
                                    sx={{display:'flex',flexDirection:'row',justifyContent:'space-between'}}
                                >
                                    <Typography variant="h4" sx={{fontWeight:'bold'}}>{t('helpers.location')}</Typography>
                                    <Button size="small" variant='text' target="_blank" href={'http://maps.google.com/maps?daddr='+parseFloat(merchant.latitud)+','+parseFloat(merchant.longitud)} >
                                        <Typography color='#0076B6' variant='caption' >
                                            {t('actions.directions')}
                                        </Typography>
                                    </Button>

                                </Box>
                                <Typography variant="h5" component='p' color={'#454545'} mb={3}>{merchant.address}</Typography>
                                <Grid container spacing={3}>
                                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                        <MapContainer
                                            center={{lat:merchant.latitude, lng:merchant.longitude}}
                                            coordenadas={{lat:merchant.latitude, lng:merchant.longitude}}
                                        />
                                    </Grid>
                                </Grid>
                        </Grid>
                    }
                </Grid>
            </Container>

            <Review
                type='merchant'
                toUUID={merchant.uuid}
                name={merchant.merchant}
                image={imagesURL+'empresas/'+merchant.profile_image}
                open={openReview}
                handleClose={()=>handleCloseReview()}
            />
            <Reserve
                type='merchant'
                toUUID={merchant.uuid}
                name={merchant.merchant}
                image={imagesURL+'empresas/'+merchant.profile_image}
                open={openReserve}
                handleClose={()=>handleCloseReserve()}
            />
        </Box>
    )
}